<section class="suggestion-wrapper Auto_Value {{fieldTemplate|lowercase}}_template" dlsTooltip="{{tooltip}}"
         [tooltipPosition]="'Right'" [tooltipClass]="'pt-light'" #tooltipElement (mouseenter)="showTooltip()">
  <ng-container [ngSwitch]="fieldTemplate">
    <ng-container *ngSwitchCase="'twolines'">
      <img *ngIf="image" src="{{image}}" class="suggestion-picture"/>
      <div class="main_value">{{mainValue}}</div>
      <div class="sub_value {{(displayValue|async)?.className}}" *ngIf="!!(displayValue|async)?.display">{{((displayValue|async)?.display)}}</div>
    </ng-container>
    <ng-container *ngSwitchCase="'additional-parenthesis'">
      <img *ngIf="image" src="{{image}}" class="suggestion-picture"/>
      <div *ngIf="!((displayValue|async)?.display)" class="main_value {{(displayValue|async)?.className}}">{{mainValue}}</div>
      <div *ngIf="((displayValue|async)?.display)" class="main_value {{(displayValue|async)?.className}}">{{mainValue}} ({{((displayValue|async)?.display)}})</div>
    </ng-container>
    <ng-container *ngSwitchCase="'hide-main-value'">
      <img *ngIf="image" src="{{image}}" class="suggestion-picture"/>
      <span *ngFor="let value of displayValue|async"
            class="sub_value {{value.className}} {{value.display.split(' ').join('_').toLowerCase()}}">
        {{value.display}}
      </span>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <img *ngIf="image" src="{{image}}" class="suggestion-picture"/>
      <ng-container *ngIf="translate"><span class="main_value">{{mainValue|translate}}</span></ng-container>
      <ng-container *ngIf="!translate"><span class="main_value">{{mainValue}}</span></ng-container>

      <span *ngFor="let value of displayValue|async"
            class="sub_value {{value.className}} {{value.display.split(' ').join('_').toLowerCase()}}">
        <ng-container *ngIf="translate">{{value.display|translate}}</ng-container>
        <ng-container *ngIf="!translate">{{value.display}}</ng-container>
      </span>
    </ng-container>
  </ng-container>
</section>
